<template>
    <div class="contenedor">
        <div class="formulario_login">
            <b-container fluid="">
                <form @submit.prevent="iniciar_sesion">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                Iniciar sesión
                            </h3>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="">Usuario</label>
                            <input type="text" v-model="usuario" class="form-control form-control-sm">
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="">Contraseña</label>
                            <input type="password" v-model="pwd" class="form-control form-control-sm">
                        </div>
                        <div class="col-sm-12 mt-3">
                            <button type="submit" class="btn btn-primary btn-block">Iniciar sesión</button>
                        </div>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import { atexto } from '@/components/functions/alertas'
    export default {
        name: 'Login',
        computed: {
            ...mapState(['preferencias']),
            ...mapGetters(['URL_SERVIDOR'])
        },
        data() {
            return {
                usuario: '',
                pwd: '',
            }
        },
        methods: {
            async iniciar_sesion() {
                let formulario = {
                    identifier: this.usuario.trim(),
                    password: this.pwd.trim()
                }

                try {

                    let query = await axios.post(`${this.URL_SERVIDOR}/api/auth/local`, formulario)
                    if (query.data.message == 'Invalid identifier or password') {
                        alert('USUARIO Y/O CONTRASEÑA INVALIDOS_')
                    } else if (query.data.user.blocked) {
                        alert('USUARIO BLOQUEADO POR ADMINISTRADOR_')
                    } else {
                        this.set_token_sesion(query.data.jwt)
                        this.$router.replace('empresas')
                    }

                } catch (e) {

                    if (e.response.data.error.message == 'Invalid identifier or password') {
                        atexto({
                            titulo: 'Error de autenticación',
                            cuerpo: 'Usuario y/o contraseña son invalidos',
                            icono: 'error'
                        })
                    } else if (e.response.data.error.message == 'Your account has been blocked by an administrator') {
                        atexto({
                            titulo: 'Usuario bloqueado',
                            cuerpo: 'Temporalmente no tienes acceso al sistema',
                            icono: 'error'
                        })
                    } else {
                        alert('ERROR DESCONOCIDO')
                    }

                }
            },
            ...mapMutations(['set_token_sesion'])
        },
    }
</script>

<style>
    .contenedor {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .formulario_login {
        width: 400px;
        height: auto;
    }
</style>